import { addMessage, whatsNextHelp } from '../config/chatUtils';
import chatElements from '../config/chatElements';
import { setCurrentFlow, getCurrentFlow } from '../config/chatState';

const { chatInput } = chatElements;

// GET STARTED FLOW
function startGetStartedFlow(first = null) {
    setCurrentFlow('getstarted');

    if (first) {
        addMessage("I\'m interested in getting a quote", "user", 500);
    }

    addMessage("Great! Fill out the form to begin!", 'bot', 1250);

    setTimeout(() => {
        chatInput.disabled = true;
    }, 1500);

    setTimeout(() => {
      const currentPath = window.location.pathname.replace(/\/$/, '');

      const isHome = currentPath === '' || currentPath === '/';

      if (!(isHome)) {
        // On some other page: go to homepage with the anchor
        window.location.href = '/#get-started';
      } else {
        // Already on homepage: just scroll
        scrollToAnchorWithOffset('get-started', 125);
      }
    }, 2000);

    setTimeout(() => {
         whatsNextHelp('getstarted');
    }, 3500);
}

function scrollToAnchorWithOffset(anchorId, offset = 125) {
    const anchor = document.getElementById(anchorId);
    if (!anchor) return;

    const targetPosition = anchor.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
    });
}

export { 
    startGetStartedFlow
};